<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../../types';
    import type {Document} from 'typings/portaro.be.types';
    import type {YearMonth} from 'shared/components/kp-calendar/types';
    import {getPageContext} from 'shared/layouts/page-context';
    import {exists} from 'shared/utils/custom-utils';
    import {AttendanceCalendar, MonthSelector} from 'src/features/erp-sutor/features/attendance-calendar';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let injectedUserRecord: Document | null = null;

    const userRecord = exists(injectedUserRecord) ? injectedUserRecord : getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>().staticData.userRecord;

    let yearMonth: YearMonth | null = null;
    const handleMonthSelected = (event: CustomEvent<YearMonth>) => {
        yearMonth = event.detail;
    };
</script>

<div class="sutor-user-attendance-tab">
    <KpHeading type="h2">Docházka</KpHeading>
    <MonthSelector on:month-selected={handleMonthSelected}/>

    {#if !exists(yearMonth)}
        <IconedContent align="center" justify="center" orientation="vertical" icon="info">
            Nejprve vyberte měsíc, pro který chcete zobrazit docházku.
        </IconedContent>
    {:else}
        <AttendanceCalendar {yearMonth} userRecordId="{userRecord.id}" type="month-with-summary"/>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .sutor-user-attendance-tab {
        display: flex;
        flex-direction: column;
        gap: @spacing-l;
    }
</style>
